/* eslint-disable no-unused-expressions */
/******************************************************************************
 * Logger Class
 * version: 1.0.2, release: 05.07.2019
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * // 		console.log('%c' + e, 'color:#f9f');

 * 
******************************************************************************/

import DateFormat from "./DateFormat";
import { fm } from "./FileManager";
// import moment from 'moment';

const fs = window.require? window.require('fs'): null;

// const version = '1.0.4';
// const release = '09.08.2019';
const CR = '\r\n';
const firstLine = '================================================================================'
	+ CR + 'session started: ' + DateFormat(new Date(), 'yyyy-mm-dd HH:MM:ss.l')
	+ CR + '================================================================================'


//============================================================================= Logger Class
export default class Logger {
	static currentLogger;
	static version = '1.0.9'
	static release = '19.09.2024'

	// ---defaults settings. can override in constructor with props
	name = 'Logger'		//default. change this if you want to use more than one logger
	enabled = true;
	prefix = '.log';
	delim = ' ';
	numDigits = 5;

	currentLogger = this;
	cummulate = true;
	traceLogs = true;			//show logs also on console output
	useLogList = false;
	useLogString = false;
	lineCounter = 0;
	timeFormat = 'HH:MM:ss.l';	//e.g. 15:23:47.123
	textColor = '#f9f';		//textcolor for console output
	useCache = null;			//cache event log to localStore
	logFile = '';				//current daily log file name
	logFilePath = '';			//current daily fille log file path
	logList = []
	logString = ''


	// ------------------------------------------------------------------------ constructor
	constructor(path, props){
		// this.path = path || (fm.exists('./public/')? './public/' : './') + 'logs/';
		// this.path = path || process.env.PUBLIC_URL + '/logs/';
		this.logFolder = path || './logs/';

		this.onLog = null;				//optional onLog event handler

		//default title. can be overriden in constructor
		this.title = 'init ' + this.name + ' | version: ' + Logger.version + ' | release: ' + Logger.release;

		Object.assign(this, props);		//override default settings

		this.last = '';
		this.lastTime = '';
		this.cummCount = 0;

		fm.createPath(this.logFolder);
		this.append(firstLine);

		if (this.title)	this.log(this.title);
		return this;
	}

	// set enabled(val){
	// 	this.enabled = val;
	// }

	// get enabled(){
	// 	return this.enabled
	// }


	// ------------------------------------------------------------------------ start
	start(){
		this.enabled = true;
	}


	// ------------------------------------------------------------------------ stop
	stop(){
		this.enabled = false;
	}


	// ------------------------------------------------------------------------ log
	log(...val){
		// if (this.traceLogs) console.log('>', ...val);

		let msg = val.join(this.delim);

		if (this.traceLogs) console.log('%c' + msg, 'color:' + this.textColor);
		if (!this.enabled) return;

		// let now = Date.now();

		if (this.cummulate){
			if (msg === this.last){	//same as message before
				this.cummulate ++
				// this.lastTime = now.format(this.format);
				this.lastTime = DateFormat(new Date(), this.timeFormat)
				return;

			}else{					//new message
				if (this.cummCount){
					let m = this.last
					msg = CR + String(this.lineCounter).padStart(this.numDigits, '0')
						+ ' ' + this.lastTime + ' (' + this.cummCount + ') '
						+ m + CR + msg
					this.cummCount = 0
					this.last = m
				}else{
					this.last = msg
				}
			}
		}else{
			this.last = msg
		}

		let str = String(this.lineCounter).padStart(this.numDigits, '0')
			+ ' ' + DateFormat(new Date(), this.timeFormat)
			+ ' ' + msg;
		
		if (this.useLogList) this.logList.push(str)
		if (this.useLogString) this.logString += (CR + str)

		this.onLog?.(val, str)

		return this.append(str)
	}


	// ------------------------------------------------------------------------ append
	append(str){
		// let day = moment().format('YYYY-MM-DD');
		let day = DateFormat(new Date(), 'yyyy-mm-dd')
		if (day !== this.currentDay) this.initLogFile(day)

		if (this.useCache !== null) this.useCache += (CR + str)

		if (fs){
			try{
				fs.appendFileSync(this.logFilePath, CR + str, 'utf8'); //add cr in first logline
			}catch(err){
				console.error('error on writing log entry', this.logFilePath)
			}
		}
		this.lineCounter ++
		return str
	}


	// ------------------------------------------------------------------------ initLogFile
	initLogFile(day){
		if (!fs) return

		this.currentDay = day
		// this.logFile = moment().year() + '/' + day + this.prefix;
		this.logFile = new Date().getFullYear() + '/' + day + this.prefix
		this.logFilePath = this.logFolder + this.logFile
		fm.createPath(this.logFilePath)

		console.log('logger: init new logfile:', this.logFilePath)
	}


	// ------------------------------------------------------------------------ log
	static log(val){
		//
	}
}


/*

localStorage.setItem('lastSession', moment.format('DD.MM.YYYY HH:mm:ss'));
moment.format('HH:mm:ss');


--last saved log:-----------------------------------------------
ID              : [Agent]
last startTime  : undefined
last playTime   : 3445
last exit event : unknown
----------------------------------------------------------------

0000 [09:06:26] --- [Agent] | VERSION 2.1.12 | Wed Mar 6 09:06:25 GMT+0100 2019 ---
*/
